import type { DriveStatusResponse } from "@scoach/types";

import { api } from "./http.ts";

/**
 * Account-level Google Drive connection for "Export to Drive". The one-time consent
 * (getDriveAuthCode in lib/googleToken) yields a code that /drive/connect exchanges for a
 * server-stored refresh token. Shared by the Settings panel and the Summary export button.
 */
export const driveApi = {
  /** Whether the user has connected Drive, plus the target export folder name. */
  status: () => api<DriveStatusResponse>("/drive/status"),

  /** Exchange a GIS authorization code for a stored Drive refresh token. */
  connect: (code: string) =>
    api<DriveStatusResponse>("/drive/connect", { method: "POST", body: { code } }),

  /** Forget the stored refresh token (user disconnects Drive). */
  disconnect: () => api<DriveStatusResponse>("/drive/disconnect", { method: "POST", body: {} }),
};
